import React from "react";

const DynamicCheckbox = ({
  label,
  id,
  fieldName,
  isChecked,
  onChange,
  isDisabled = false,
  showError = false,
  errorMessage = "Please choose one.",
}) => {
  return (
    <div className="flex items-center space-x-6 pl-2">
      <label className="flex items-center space-x-2 select-none">
        <input
          type="checkbox"
          name={fieldName}
          id={fieldName}
          disabled={isDisabled}
          checked={isChecked || false}
          onChange={(e) => onChange(e)}
          className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
        />
        <span className="text-base font-medium text-black">{label}</span>
      </label>
      {showError && !isChecked && (
        <p className="text-base text-red-500 mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default DynamicCheckbox;
